import { DELEGATIONS_URLS } from './endpoints.constants';

const API_URL = process.env.API_URL;

const ENDPOINTS_DELEGATIONS = {
  get: {
    delegations: (employeeId) => `${API_URL}/${DELEGATIONS_URLS.ROOT}/${employeeId}`,
    delegableEmployees: (employeeId) => `${API_URL}/${DELEGATIONS_URLS.DELEGABLE_EMPLOYEES}/${employeeId}`,
  },
  post: {
    delegations: (employeeId) => `${API_URL}/${DELEGATIONS_URLS.ROOT}/${employeeId}`,
  },
  put: {
    delegations: (employeeId) => `${API_URL}/${DELEGATIONS_URLS.ROOT}/${employeeId}`,
  },
  delete: {
    delegations: (employeeId) => `${API_URL}/${DELEGATIONS_URLS.ROOT}/${employeeId}`,
  },
};

export {
  ENDPOINTS_DELEGATIONS
};



// WEBPACK FOOTER //
// ./client/app/common/endpoints/delegations.endpoints.js